import React from 'react';
import styled from 'styled-components';
import { Card, CardContent, Divider, Grid } from '@material-ui/core';
import { AppDashboardNamedDataType, AppDashboardSplitType } from '../../../types/generated';
import { format } from 'date-fns';
import { InstallsChart } from './ChartComponents/InstallsChart';
import { InstallsByCountry } from './ChartComponents/InstallsByCountryChart';

const DashboardCard = styled(Card)`
    border-top: 8px solid ${props => props.theme.light};
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.04);
`;

const DashboardChartLabels = styled.div`
    display: flex;
    justify-content: space-between;
    user-select: none;
`;

const SpacedDivider = styled(Divider)`
    margin: 16px 0;
`;

interface ExtranetHomeDashboardProps {
    from: Date;
    to: Date;
    split: AppDashboardSplitType;
    data?: {
        installations: AppDashboardNamedDataType[];
        uninstallations: AppDashboardNamedDataType[];
        installationsByCountry: AppDashboardNamedDataType[];
    };
}

const DashboardDateFormatter = (date: Date) => {
    return format(date, 'MMM yyyy');
};

export const DashboardChartLabelsComponent = ({
    from,
    to,
}: {
    from: Date;
    to: Date;
}): JSX.Element => (
    <>
        <SpacedDivider />
        <DashboardChartLabels>
            <label>{DashboardDateFormatter(from)}</label>
            <label>{DashboardDateFormatter(to)}</label>
        </DashboardChartLabels>
    </>
);

export const ExtranetHomeDashboard = ({
    from,
    to,
    split,
    data = {
        installations: [{ label: 'Not available', amount: 0 }],
        uninstallations: [{ label: 'Not available', amount: 0 }],
        installationsByCountry: [{ label: 'Not available', amount: 0 }],
    },
}: ExtranetHomeDashboardProps): JSX.Element => (
    <>
        <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={6}>
                <DashboardCard>
                    <CardContent>
                        <InstallsChart
                            split={split}
                            installations={data.installations}
                            uninstallations={data.uninstallations}
                        />
                        <DashboardChartLabelsComponent from={from} to={to} />
                    </CardContent>
                </DashboardCard>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
                <DashboardCard>
                    <CardContent>
                        <InstallsByCountry installationsByCountry={data.installationsByCountry} />
                        <DashboardChartLabelsComponent from={from} to={to} />
                    </CardContent>
                </DashboardCard>
            </Grid>
        </Grid>
    </>
);
